import 'css-chunksrc/client/pages/exportsPage/resourceProjectAllocation/filters/styles.scss';export default {
  "filters": "_filters_rahqm_1",
  "resetButton": "_resetButton_rahqm_17",
  "label": "_label_rahqm_25",
  "section": "_section_rahqm_32"
};